import { createFileRoute } from "@tanstack/react-router";
import { StickyHeader } from "@/components/site/StickyHeader";
import { Hero } from "@/components/site/Hero";
import { Testimonials } from "@/components/site/Testimonials";
import { ResultsStrip } from "@/components/site/ResultsStrip";
import { WhyWorkWithMe } from "@/components/site/WhyWorkWithMe";
import { HowItWorks } from "@/components/site/HowItWorks";
import { BeforeAfter } from "@/components/site/BeforeAfter";
import { ReferralCTA } from "@/components/site/ReferralCTA";
import { ContactForm } from "@/components/site/ContactForm";
import { Footer } from "@/components/site/Footer";
import { AIChatWidget } from "@/components/site/AIChatWidget";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "Inbound Growth for Financial Advisors | Katie Fernands" },
      {
        name: "description",
        content:
          "Grow your book without cold calls. Predictable inbound pipeline for RIAs, banks, and fintech advisors via LinkedIn, content, and warm outreach.",
      },
      { property: "og:title", content: "Inbound Growth for Financial Advisors" },
      {
        property: "og:description",
        content:
          "A predictable pipeline built on trust. 15+ years turning advisor expertise into inbound leads.",
      },
      { property: "og:url", content: "https://katiefernands.com/" },
      { property: "og:type", content: "website" },
      { name: "twitter:title", content: "Inbound Growth for Financial Advisors" },
      {
        name: "twitter:description",
        content:
          "Predictable pipeline for RIAs, banks, and fintech advisors. No cold calls.",
      },
    ],
    links: [{ rel: "canonical", href: "https://katiefernands.com/" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ProfessionalService",
          name: "Katie Fernands",
          description:
            "Inbound lead generation and growth strategy for RIAs, banks, and fintech advisors.",
          areaServed: "US",
          serviceType: "Inbound Lead Generation for Financial Advisors",
          provider: {
            "@type": "Person",
            name: "Katie Fernands",
            jobTitle: "Growth Strategist for Financial Advisors",
            url: "https://www.linkedin.com/in/katiefernands/",
          },
        }),
      },
    ],
  }),
  component: Home,
});


function Home() {
  return (
    <div className="bg-background text-foreground">
      <StickyHeader />
      <main>
        <Hero />
        <Testimonials />
        <ResultsStrip />
        <WhyWorkWithMe />
        <HowItWorks />
        <BeforeAfter />
        <ReferralCTA />
        <ContactForm />
      </main>
      <Footer />
      <AIChatWidget />
    </div>
  );
}
